import { render, staticRenderFns } from "./AddTemplatePanel.vue?vue&type=template&id=783b8fa2&scoped=true&"
import script from "./AddTemplatePanel.vue?vue&type=script&lang=js&"
export * from "./AddTemplatePanel.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplatePanel.vue?vue&type=style&index=0&id=783b8fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783b8fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('783b8fa2')) {
      api.createRecord('783b8fa2', component.options)
    } else {
      api.reload('783b8fa2', component.options)
    }
    module.hot.accept("./AddTemplatePanel.vue?vue&type=template&id=783b8fa2&scoped=true&", function () {
      api.rerender('783b8fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/AddTemplatePanel.vue"
export default component.exports